import type { ColumnDef } from '@tanstack/react-table';
import { createAppColumnHelper, type DataTableFeatures } from 'design-system';

import type { CsvFormattedRow, CsvHeaderColumn } from './api/csvTable.transform';

export type CsvTableDataRow = CsvFormattedRow;

export type CsvColumnAlignments = Record<string, 'left' | 'right' | 'center' | undefined>;

const columnHelper = createAppColumnHelper<CsvTableDataRow>();

function getDataTableAlignment(alignment: CsvColumnAlignments[string]): 'start' | 'center' | 'end' {
  if (alignment === 'right') return 'end';
  if (alignment === 'center') return 'center';
  return 'start';
}

export function getCsvTableColumns(
  headerColumns: CsvHeaderColumn[],
  alignments: CsvColumnAlignments
): ColumnDef<DataTableFeatures, CsvTableDataRow>[] {
  return columnHelper.columns(
    headerColumns.map(column =>
      columnHelper.accessor(row => row.cells[column.position] ?? '', {
        id: column.id,
        header: column.name,
        cell: context => context.getValue(),
        meta: { align: getDataTableAlignment(alignments[column.name]) }
      })
    )
  );
}
